import React from "react";

const Animation = ({
  children,
  expand = true,
  className = "",
}: {
  children: React.ReactElement;
  expand?: boolean;
  className?: string;
}) => {
  return (
    <div
      className={`qashqool-fade-in flex flex-col p-0 m-0 ${
        expand ? "grow" : ""
      } ${className}`}
      style={{ minHeight: expand ? "84vh" : "unset" }}
    >
      {children}
    </div>
  );
};

export default Animation;
